import { render, staticRenderFns } from "../template/sub-components/modal-add-user.html?vue&type=template&id=28605824&scoped=true&external"
import script from "./ModalAddNewUser.vue?vue&type=script&lang=js"
export * from "./ModalAddNewUser.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewUser.vue?vue&type=style&index=0&id=28605824&prod&lang=scss"
import style1 from "./ModalAddNewUser.vue?vue&type=style&index=1&id=28605824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28605824",
  null
  
)

export default component.exports